export default [
  {
    title: "Peters Computer einrichten",
    description: "Peter hat einen neuen Computer, aber weiß nicht wie man ihn einrichtet. Führe ein Video-Telefonat mit ihm über die Plattform und zeige ihm wie es geht.",
    points: 5,
    isCompleted: true,
    isConfirmable: false
  },
  {
    title: "Für Oma einkaufen",
    description: "Bitte geh für deine Oma einkaufen. Sie braucht dich. <3",
    points: 10,
    isCompleted: false,
    isConfirmable: false
  },
  {
    title: "Spargel ernten",
    description: "Landwirte brauchen motivierte und ausdauernde Arbeitskräfte für die Spargelernte",
    points: 50,
    isCompleted: false,
    isConfirmable: true
  }
];